import {getConfigFields} from '../fields.js'
import {formFieldIds} from '../values.js'

const {postalCode, plate, vehicleStatus} = formFieldIds

const formVehicleExtraDataFieldsConfig = [
  getConfigFields[plate](),
  getConfigFields[vehicleStatus](),
  getConfigFields[postalCode]({customProps: {help: 'Te mostraremos profesionales cerca de ti'}})
]

export const formVehicleExtraDataFormConfig = {
  fields: formVehicleExtraDataFieldsConfig
}
